import LoadingSpinner from "./LoadingSpinner";

/**
 * Full-viewport loading state — dùng cho Suspense fallback hoặc app-level boot.
 */
const LoadingPage = ({ message = "Đang tải..." }: { message?: string }) => {
    return <LoadingSpinner message={message} fullPage size="large" />;
};

export default LoadingPage;
